import styled from '@emotion/styled'
import { Theme } from '@emotion/react'
import _ from 'lodash'

const L2SurfaceBase = styled.div(({theme}) => ({
	borderRadius: theme.borderRadius,
	padding: theme.spacing(2, 2.5),
	display: 'flex',
	flexDirection: 'column',
	gap: theme.spacing(1),
}))

export interface L2SurfaceProps {
	print?: boolean
	tier?: number|string
	outline?: boolean
}

const L2Surface = styled(L2SurfaceBase)(({theme, print, tier, outline}: L2SurfaceProps & { theme: Theme }) => {
	if(outline) {
		return {
			border: `1px solid ${theme.colors.lines}`,
		}
	}
	let backgroundColor = print ? theme.colors.pdfGray : theme.colors.second
	if(_.isString(tier)) {
		tier = parseInt(tier)
	}
	switch(tier) {
		case 0:
			backgroundColor = theme.colors.transparent
			break
		case 1:
			// default background color
			break
		case 2:
			backgroundColor = theme.colors.third
			break
	}
	return {
		backgroundColor,
	}
})

export default L2Surface
